export default __webpack_public_path__ + "static/media/testimonials_icon.f8708ddf.svg";